export const STRIPE_LINKS = {
  monthly: "https://buy.stripe.com/eVq00icuo8FFewWcoucV204",
  annual: "https://buy.stripe.com/28E28q3XSf43bkK74acV205",
  archiveBase: "https://buy.stripe.com/6oU14m660dZZbkK74acV20a",
  archivePro: "https://buy.stripe.com/28EeVc1PKdZZgF41JQcV20b",
  fascicoloPro: "https://buy.stripe.com/3cI00ieCwf43gF474acV209",
};

export const withEmail = (link, email) =>
  email ? `${link}?prefilled_email=${encodeURIComponent(email)}` : link;
